export default __webpack_public_path__ + "static/media/youtube.678ca09d.svg";